/* LIRO theme scripts: mobile menu + "My Space" saving. Vanilla, no dependencies.
 * My Space v1 stores ONLY product handles in localStorage (no personal data, no documents). */
(() => {
  const KEY = 'liro:myspace:v1';

  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '{}');
      return { designs: Array.isArray(v.designs) ? v.designs.filter((h) => typeof h === 'string') : [] };
    } catch (e) {
      return { designs: [] };
    }
  };
  const write = (state) => {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* storage unavailable: degrade silently */ }
  };

  window.liroMySpace = {
    has: (handle) => read().designs.includes(handle),
    toggle(handle) {
      const s = read();
      const i = s.designs.indexOf(handle);
      if (i > -1) s.designs.splice(i, 1); else s.designs.push(handle);
      write(s);
      document.dispatchEvent(new CustomEvent('liro:myspace', { detail: { designs: s.designs.slice() } }));
      return i === -1;
    },
    all: () => read().designs,
  };

  const syncButtons = () => {
    const saved = new Set(read().designs);
    document.querySelectorAll('[data-liro-save]').forEach((btn) => {
      const on = saved.has(btn.dataset.liroSave);
      btn.setAttribute('aria-pressed', String(on));
      const label = btn.querySelector('.lsr');
      if (label) label.textContent = (on ? 'Remove from My Space: ' : 'Save to My Space: ') + (btn.dataset.liroName || '');
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-liro-save]');
    if (btn) {
      const added = window.liroMySpace.toggle(btn.dataset.liroSave);
      syncButtons();
      const live = document.getElementById('liro-live');
      if (live) live.textContent = added ? 'Saved to My Space' : 'Removed from My Space';
      return;
    }
    const toggle = e.target.closest('[data-liro-menu]');
    if (toggle) {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      if (panel) panel.dataset.open = String(open);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const t = document.querySelector('[data-liro-menu][aria-expanded="true"]');
    if (t) { t.click(); t.focus(); }
  });

  const syncCount = () => {
    const n = read().designs.length;
    document.querySelectorAll('[data-liro-count]').forEach((el) => { el.textContent = n ? String(n) : ''; el.hidden = !n; });
  };

  document.addEventListener('DOMContentLoaded', () => { syncButtons(); syncCount(); });
  document.addEventListener('liro:myspace', () => { syncButtons(); syncCount(); });
})();
